export default __webpack_public_path__ + "static/media/2.79497f1e.webp";